import { useEffect, useState } from 'react';
import { initial } from 'lodash';

import { isSameLanguage } from 'src/data/generation';

const findById = (list, searchId) => list.find(({ id }) => id === searchId);

export const useVisiblePersonas = ({
  loading,
  personas,
  suggestedPersonas,
  selectedPersona,
  visibleCount,
  language,
}) => {
  const [visible, setVisible] = useState([]);
  const [merged, setMerged] = useState([]);

  useEffect(() => {
    const combinedPersonas = [...personas, ...(suggestedPersonas || [])];

    const sortedPersonas = combinedPersonas.sort((a, b) => {
      const sortByLanguage = (persona) =>
        isSameLanguage(persona.brandVoice?.language, language) ? 0 : 1;
      return sortByLanguage(a) - sortByLanguage(b);
    });

    setMerged(sortedPersonas);
  }, [personas, suggestedPersonas, visibleCount, language]);

  useEffect(() => {
    if (loading) {
      return;
    }

    setVisible(() => merged.slice(0, visibleCount));
  }, [merged, loading, visibleCount]);

  useEffect(() => {
    if (loading) {
      setVisible((visible) => {
        const placeholders = Array(visibleCount).fill({ isPlaceholder: true });
        return [...visible, ...placeholders].slice(0, visibleCount);
      });
    }
  }, [loading, visibleCount]);

  useEffect(() => {
    if (selectedPersona?.id && visible.length) {
      const hiddenSelected = visible.findIndex(({ id }) => id === selectedPersona.id) === -1;
      const hiddenPersona = hiddenSelected && findById(merged, selectedPersona.id);

      if (hiddenPersona) {
        setVisible((visible) => [hiddenPersona, ...initial(visible)]);
      }
    }
  }, [selectedPersona, visible, merged]);

  return visible;
};
